module.exports = __webpack_public_path__ + "img/20180815_150119_062.1e0e55ee.jpg";